import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import { FontAwesomeIcon } from '../../atoms/icon/icon';
import { Option } from '../../atoms/select';
import { SingleLineEllipsis } from '../../styles';
import { HeadingCompact00 } from '../../styles/typography';

const GroupHeadingLabel = styled.div`
  ${SingleLineEllipsis};
`;
const GroupHeadingIconWrapper = styled.div`
  padding: var(--spacing-01);
`;
const Wrapper = styled.div`
  ${HeadingCompact00};
  padding: var(--spacing-02) var(--spacing-03) var(--spacing-02)
    var(--spacing-04);
  height: 32px;
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export interface GroupHeadingProps {
  onClick: () => void;
  data: { label: string; options: Option[] };
  key: string;
  active: boolean;
  value: any[];
  setValue: (option: Option[]) => void;
}

export const GroupHeading = ({
  onClick,
  data,
  key,
  active,
}: GroupHeadingProps) => {
  return (
    <Wrapper onClick={onClick} data-key={key}>
      <GroupHeadingIconWrapper>
        <FontAwesomeIcon
          icon={active ? faChevronDown : faChevronRight}
          size={12}
        />
      </GroupHeadingIconWrapper>
      <GroupHeadingLabel>{data.label}</GroupHeadingLabel>
    </Wrapper>
  );
};
